import { render, staticRenderFns } from "./acceptanceDetails.vue?vue&type=template&id=5b081468&scoped=true"
import script from "./acceptanceDetails.vue?vue&type=script&lang=js"
export * from "./acceptanceDetails.vue?vue&type=script&lang=js"
import style0 from "./acceptanceDetails.vue?vue&type=style&index=0&id=5b081468&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b081468",
  null
  
)

export default component.exports